import * as Complex from '../../../../process-data/complex';

export function computeComplexAlphaPlus(complexDenominator, c2, r2, sImaginary) {
  var result = Complex.createComplex(0, sImaginary * c2 * r2).divide(complexDenominator);
  return result;
}

export function computeComplexFF(complexRParallel, r1) {
  var result = complexRParallel.divide(Complex.createComplex(r1, 0));
  return result;
}
